'use client'

import { Tab } from '@macarongfactory/web-ui'

import { getRankTabLabel, RANK_TABS } from '../_features/rank'

import type { TRankTab } from '../_features/rank'

interface IRankTabsProps {
  activeTab: TRankTab
  /** 전기차 여부 — 실연비 탭 라벨을 '실전비순'으로 표기 */
  isElectric: boolean
  onSelect: (tab: TRankTab) => void
}

/**
 * 랭킹 탭 (만족도순 / 실연비순 / 유류비순) — sticky.
 * 검색 헤더(모바일 48 / 데스크탑 65) 바로 아래에 고정. 인앱은 헤더가 없어
 * 상위에서 `--rank-tab-top: 0px`를 주입한다(미지정 시 48px 폴백).
 */
const RankTabs = ({ activeTab, isElectric, onSelect }: IRankTabsProps) => {
  return (
    <nav
      className='sticky top-[var(--rank-tab-top,48px)] z-20 border-b border-stroke-neutral-normal bg-background-surface-default lg:top-[65px]'
      aria-label='랭킹 기준 선택'
    >
      {/* 바(배경·디바이더)는 full, 탭 아이템은 최대 1200px 센터 정렬 (WEB-4616) */}
      <div className='mx-auto w-full max-w-[1200px]'>
        <Tab scrollable={false}>
          {RANK_TABS.map(tab => (
            <Tab.TabItem
              key={tab.id}
              text={getRankTabLabel(tab, isElectric)}
              selected={tab.id === activeTab}
              clickable={() => onSelect(tab.id)}
            />
          ))}
        </Tab>
      </div>
    </nav>
  )
}

export default RankTabs
